import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AlertMessageInterfaceState } from '../../store/state/alert-message.state';
import { PriceDetailsInterface } from '../../models/price-details.interface';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-procedure-card',
  templateUrl: './procedure-card.component.html',
  styleUrls: ['./procedure-card.component.css'],
  standalone: false
})
export class ProcedureCardComponent implements OnInit {

  @Input()
  icon?: string;

  @Input()
  text: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  @Input()
  status?: string;

  @Input()
  cursor: boolean;

  @Input()
  value: string;

  @Input()
  longText?: boolean;

  @Input()
  extra: string;

  brand: string;

  constructor(public store: Store<AlertMessageInterfaceState>) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    if (this.status === 'wait_form') {
      this.icon = this.icon.replace('.png', '_required_action_' + this.brand + '.png');
    }
  }
}
